import { render, staticRenderFns } from "./standart-image.vue?vue&type=template&id=6eeef8f6&scoped=true&"
import script from "./standart-image.vue?vue&type=script&lang=ts&"
export * from "./standart-image.vue?vue&type=script&lang=ts&"
import style0 from "./standart-image.vue?vue&type=style&index=0&id=6eeef8f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eeef8f6",
  null
  
)

export default component.exports